// extracted by mini-css-extract-plugin
export default {"Scroll_Top_button":"topButton_Scroll_Top_button__Mnj51","Scroll_Down_button":"topButton_Scroll_Down_button__kkVNb"};